import React from 'react';
import { motion } from 'framer-motion';
import './SocialIcons.css';

function SocialIcons() {
  const iconVariants = {
    hover: {
      scale: 1.2,
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 10
      }
    }
  };

  return (
    <div className="social-icons">
      <motion.a 
        href="https://www.youtube.com/@VueloDespierto" 
        target="_blank" 
        rel="noopener noreferrer"
        whileHover="hover"
        variants={iconVariants}
      >
        <i className="fab fa-youtube"></i>
      </motion.a>
      <motion.a 
        href="https://www.instagram.com/vuelo.despierto/" 
        target="_blank" 
        rel="noopener noreferrer"
        whileHover="hover"
        variants={iconVariants}
      >
        <i className="fab fa-instagram"></i>
      </motion.a>
      <motion.a 
        href="https://distrokid.com/hyperfollow/vuelodespierto/pociones-en-vivo" 
        target="_blank" 
        rel="noopener noreferrer"
        whileHover="hover"
        variants={iconVariants}
      >
        <i className="fab fa-spotify"></i>
      </motion.a>
    </div>
  );
}

export default SocialIcons; 